'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_totp_Migration$$anon$4(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_ui_totp_Migration$$anon$4 as $c_Lpresto_ui_totp_Migration$$anon$4 };
$p = $c_Lpresto_ui_totp_Migration$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_ui_totp_Migration$$anon$4;
/** @constructor */
function $h_Lpresto_ui_totp_Migration$$anon$4() {
}
export { $h_Lpresto_ui_totp_Migration$$anon$4 as $h_Lpresto_ui_totp_Migration$$anon$4 };
$h_Lpresto_ui_totp_Migration$$anon$4.prototype = $p;
$p.ky = (function(x) {
  if ((x !== null)) {
    var x68 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().Hk(x);
    if ((!x68.k())) {
      x68.q();
      return true;
    }
  }
  return false;
});
$p.ks = (function(x, default$1) {
  if ((x !== null)) {
    var x72 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().Hk(x);
    if ((!x72.k())) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__jl_Throwable__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "QR Code de 2FA ileg\u00edvel", x72.q()));
    }
  }
  return default$1.v(x);
});
$p.ca = (function(x) {
  return this.ky(x);
});
$p.bk = (function(x, default$1) {
  return this.ks(x, default$1);
});
var $d_Lpresto_ui_totp_Migration$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_totp_Migration$$anon$4, "presto.ui.totp.Migration$$anon$4", ({
  a4j: 1,
  a4: 1,
  t: 1,
  z: 1,
  a: 1
}));
export { $d_Lpresto_ui_totp_Migration$$anon$4 as $d_Lpresto_ui_totp_Migration$$anon$4 };
//# sourceMappingURL=presto.ui.totp.-Migration$$anon$4.js.map
